import { Mic } from "react-feather";
import { Input } from "reactstrap";
import SvgIcon from "../../../../CommonComponents/SvgIcon/SvgIcon";
import { Href, NameAndPhoneNumber } from "../../../../../Constants/Constants";
import { P } from "../../../../../AbstractElements";
import { ContactList } from "./ContactList";

export const ContactTabPane = () => {
  return (
    <>
      <div className="common-space">
        <P>{`Contacts`}</P>
        <div className="header-top">
          <a className="btn badge-light-primary f-w-500" href={Href}>
            <i className="fa fa-plus" />
          </a>
        </div>
      </div>
      <div className="search-contacts">
        <Input type="text" placeholder={NameAndPhoneNumber} />
        <SvgIcon iconId="stroke-search" />
        <Mic className="mic-search" />
      </div>
      <ContactList/>
    </>
  );
};
